import { z } from 'zod';
import { ContractHash, UnixTs } from '../types/branded';
import { ActionDefinitionSchema } from './action-definition';
import { EnumDefinitionSchema } from './enum-definition';
import { FieldDefinitionSchema } from './field-definition';
import { RouteDefinitionSchema } from './route-definition';

export const DomainContractSchema = z.object({
  $schema: z.string().optional(),
  schemaVersion: z.string().min(1),
  version: z.string().min(1),
  extractedAt: UnixTs,
  subproject: z.string().min(1),
  fields: z.array(FieldDefinitionSchema),
  enums: z.array(EnumDefinitionSchema),
  actions: z.array(ActionDefinitionSchema),
  routes: z.array(RouteDefinitionSchema),
  checksums: z.object({
    fields: ContractHash,
    enums: ContractHash,
    actions: ContractHash,
    routes: ContractHash,
    combined: ContractHash
  }),
  metadata: z.object({
    semanticMapPath: z.string().optional(),
    entitiesPath: z.string().optional(),
    scanDuration: z.number().optional()
  }).optional()
});

export type DomainContract = z.infer<typeof DomainContractSchema>;
